import React from 'react';
import Module from 'Components/Core/Module';
import 'CSS/Member/Member.css';
import './PageStoreGenerator.css';

export default function PageStoreGenerator(props) {

	const x = props.x;

	x.wam.init(props.id, {
		"onClose": () => {}
	});

	return (
		<Module id={props.id} x={x} title={props.title} display={props.display} displayTitle="d-block" closeButton="1">
			<div className="page-store-generator settings">
				<div className="settings-card">
					<h3 className="settings-card-title">Meine interaktive Seite</h3>
					<p>
						Hier kannst Du aus Deinen Rubriken und Seiten eine eigenständige, interaktive HTML-Seite
						erzeugen lassen (Baumstruktur mit Volltextsuche). Es werden ausschließlich Deine eigenen
						Einträge berücksichtigt - Rubriken/Seiten mit dem Merkmal "Inaktiv" werden dabei komplett
						ignoriert, "Versteckt" markierte Einträge erscheinen nicht im Baum, sind aber weiterhin
						über die Suche auffindbar.
					</p>
					<button type="button" className="btn" disabled={true} title="Folgt in einem der nächsten Schritte">
						<i className="bi bi-magic"></i>Seite erzeugen
					</button>
				</div>
			</div>
		</Module>
	)

};
